export default __webpack_public_path__ + "static/media/tvsci-logo.112f2da4.png";